import 'slick-carousel';
import {Component} from "../interface/component";

export abstract class AbstractCarouselComponent implements Component {

    protected $root:JQuery;
    protected $carousel:JQuery;
    protected $pagination:JQuery;
    protected $controls:JQuery;
    protected $scrollNext:JQuery;
    protected $scrollPrev:JQuery;

    protected constructor(elem: HTMLElement) {
        this.$root = $(elem);
        this.$carousel = this.$root.find(`.${this.getBaseJSClass()}__carousel`);
        this.loadControls();
    }

    protected loadControls() {
        this.$pagination = this.$root.find(`.js-carousel__pagination`);
        this.$controls = this.$root.find(`.js-carousel__controls`);
        this.$scrollNext = this.$root.find(`.js-carousel__control--next`);
        this.$scrollPrev = this.$root.find(`.js-carousel__control--previous`);
    }

    init() {
        this.bindUI();
    }

    protected bindUI = () => {
        this.$root.removeClass(`${this.getBaseStyleClass()}--loading`);
        this.$carousel.slick(this.getSlickParams());
        this.$carousel.on('afterChange', this.handleSlideChange);
    }

    protected handleSlideChange = (ev:any, slick:JQuerySlick, currentSlide:any) => this.$pagination.find('.js-carousel__pagination--current').text(currentSlide + 1);

    abstract getBaseStyleClass(): string;
    abstract getBaseJSClass(): string;
    abstract getSlickParams(): JQuerySlickOptions;

}
